import Discovery from './Discovery';
import UpsertTaggingWorkflowDrawer from './UpsertTaggingWorkflowDrawer';
import List from './List';
import * as Styles from './styles';
import { IProductsContext, ProductsContext } from './context';

interface IProductsProps {
  usage: IProductsContext['usage'];
}

const Products = ({ usage }: IProductsProps) => {
  return (
    <ProductsContext.Provider value={{ usage }}>
      <Styles.Wrapper>
        <Discovery />
        <List />
        {usage === 'TAGGING' && <UpsertTaggingWorkflowDrawer />}
      </Styles.Wrapper>
    </ProductsContext.Provider>
  );
};

export default Products;
